import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Container from "@mui/material/Container";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import {
  DataGridPro,
  GridActionsCellItem,
  GridToolbarFilterButton,
  GridPaginationModel,
  GridColDef,
  GridToolbarContainer,
  GridToolbarExport,
  getGridStringOperators,
  GridLogicOperator,
} from "@mui/x-data-grid-pro";

import { DataGrid } from "../../util/DataGrid";
import { ServiceName } from "../../../constants";
import { getApiCall, postApiCall } from "../../../services/apiHelper";
import { TaskmgmtServiceURL } from "../../../config/config";
import { useEffect, useState } from "react";
import { RoleModel, lazyloadingFilters } from "../../util/All_interfaces";
import { GridFilterModel } from "@mui/x-data-grid";
import { CircularProgress } from "@mui/material";
import { useResizeDetector } from "react-resize-detector";


const RoleDashboard = () => {
  const navigate = useNavigate();
  const [value, setValue] = React.useState("1");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const [fetchedRoles, setFetchedRoles] = useState<RoleModel[]>([]);
  const [pageSize, setPageSize] = useState<number>(10);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: pageSize,
  });
  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
    items: [],
    logicOperator:GridLogicOperator.And
  });

  const [filterRoles, setFilterRoles] = React.useState<lazyloadingFilters[]>([]);
  const [rowCount, setRowCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const { width,ref } = useResizeDetector();
  const [columnWidths,setColumnWidths] = useState<any>({});

  useEffect(()=>{
    if(width){
      const newColumnWidths = {
        column1:width * 0.1,
        column2:width * 0.30
      };
      setColumnWidths(newColumnWidths);
    }
  },[width]);
  const formatNumber = (params:any) => {
    if(params.value !== null)
      return<div style={{textAlign:'right',width:'85%',paddingRight:'5px'}}>
        {params.value.toLocaleString('en-US')}
      </div>
     ;
  }


  const fetchData = async (paginationModel: GridPaginationModel, filterModel: GridFilterModel) => {
    setLoading(true);
    await GetRoles(paginationModel, filterModel).then(
      (data: any) => {
        console.log(data.result);

        setFetchedRoles(data?.result?.roles);
        setRowCount(data.result.rowCount);

        // var arr = [...data?.result?.roles];
        // dummy.forEach((d:any) => {
        //   arr.push({...d,id:d.id + 14});
        // });
        // setFetchedRoles(arr);
        // setRowCount(arr.length);
      }
    ).catch((e) => {
      console.log(e);

    }).finally(() => { setLoading(false) });
  };

  const GetRoles = async (paginationModel: GridPaginationModel, filterModel: GridFilterModel) => {
    var rolesArr: any[] = [];
    filterModel?.items?.forEach((rolesFilter: any) => {
      console.log(rolesFilter);
      
      if (rolesFilter?.value != undefined) {
        rolesArr.push( {
          identity: rolesFilter?.field,
          matchMode: rolesFilter?.operator,
          value: rolesFilter?.value,
        });
      }
    });

    var url = TaskmgmtServiceURL + "/Roles/GetAllRolesDashboard";
    var payload = {
      filters: rolesArr,
      first: paginationModel.pageSize * paginationModel.page,
      filterConditionalOperator: filterModel.logicOperator,
      globalFilter: null,
      rows: paginationModel.pageSize,
      sortOrder: 1
    };
    
    if(payload.filters.length == 0){
      payload = {...payload,filterConditionalOperator:GridLogicOperator.And}
    }
    const response = postApiCall(url, payload, "TaskmgmtService").then((data: any) => data);
    return response;
  };



  useEffect(() => {
      fetchData(paginationModel, filterModel);
    
  }, [paginationModel, filterModel]);

  const columns: GridColDef[] = [
    {
      field: "action",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      disableExport: true,
      renderCell: (cellValues) => {
        const onEditClick = (e: any) => {
          e.stopPropagation(); // don't select this row after clicking
          navigate("/role/" + "edit/" + cellValues.id);
        };

        const onViewClick = (e: any) => {
          e.stopPropagation(); // don't select this row after clicking
          navigate("/role/" + "view/" + cellValues.id);
        };
        return (
          <>
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<VisibilityIcon />}
              label="View"
              onClick={(event) => {
                onViewClick(event);
              }}
            />
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<EditIcon />}
              label="Edit"
              onClick={(event) => {
                onEditClick(event);
              }}
            />
          </>
        );
      },
      width:columnWidths.column1 || 100,
    },
    { field: "role", headerName: "Role", width:columnWidths.column2 || 100,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    ) },
    { field: "region", headerName: "Region", width:columnWidths.column2 || 100,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    ) },
    { field: "lastModifiedBy", headerName: "Modified By", width:columnWidths.column2 || 100,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    ) },
  ];

  const handelPaginationModel = (e: GridPaginationModel) => {
    setPaginationModel(e);
    fetchData(e, filterModel);
  };

  const handelFilterModelChange = (model: any) => {
    setFilterModel(model);
    fetchData(paginationModel, model);
  };

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarExport />
        <GridToolbarFilterButton />
      </GridToolbarContainer>
    );
  };
  return (
    <Container maxWidth={false} className="dashboard-wrap">
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              aria-label="investment Tab"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="All Items" value="1"  sx={{textTransform:'capitalize'}}/>
            </TabList>
          </Box>
          <TabPanel ref={ref} value="1">
            {
              <DataGrid
                rows={fetchedRoles}
                rowCount={rowCount}
                columns={columns}
                paginationModel={paginationModel}
                PaginationModelChange={handelPaginationModel}
                filterModel={filterModel}
                loading={loading}
                filterModelChange={(model: GridFilterModel) => handelFilterModelChange(model)}
                customToolbar={CustomToolbar}

              />
            }
          </TabPanel>
        </TabContext>
      </Box>
    </Container>
  );
};

export default RoleDashboard;
